import { createAction } from "@reduxjs/toolkit"

export const madeBottomModalVisibleAction = createAction<{ componentName: string }>(
    "overlays/modals/madeBottomModalVisible"
)
